import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../shared';

import { RegiaoIntegracaoErpImportModalComponent } from './modal';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        RegiaoIntegracaoErpImportModalComponent
    ],
    exports: [
        RegiaoIntegracaoErpImportModalComponent
    ]
})
export class RegiaoIntegracaoErpImportModule { }
